import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Table,
  Badge,
  Progress,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import { API_MAI_FALI } from "../utils";
import { logoutUser } from "../actions/AuthAction";

const UploadDokumen = (props) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileDescription, setFileDescription] = useState("");
  const [fileCategory, setFileCategory] = useState("");
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [ormasList, setOrmasList] = useState([]);
  const [selectedOrmas, setSelectedOrmas] = useState("");

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      logoutUser(props.history);
    } else {
      fetchOrmasList();
      fetchUploadedFiles();
    }
  }, [props.history]);

  const fetchOrmasList = async () => {
    try {
      const response = await axios.get(`${API_MAI_FALI}ormas`);
      if (response.data.success) {
        setOrmasList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching ORMAS list:", error);
    }
  };

  const fetchUploadedFiles = async () => {
    try {
      const response = await axios.get(`${API_MAI_FALI}dokumen-ormas`);
      if (response.data.success) {
        setUploadedFiles(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching uploaded files:", error);
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!selectedFile || !fileDescription || !fileCategory || !selectedOrmas) {
      setError("Semua field harus diisi");
      return;
    }

    setLoading(true);
    setError("");
    setUploadProgress(0);

    try {
      const formData = new FormData();
      formData.append("ormas_id", selectedOrmas);

      // Map the file category to the correct backend field name
      const fieldMapping = {
        akta_pendirian: "akta_pendirian",
        skt_ahu: "skt_ahu",
        surat_pengesahan: "pengesahan_kemenkumham",
        surat_domisili: "surat_domisili",
        program_kerja: "program_kerja_semester_1",
        biodata_pengurus: "surat_pernyataan",
        ktp_pengurus: "rekomendasi",
        npwp_ormas: "npwp",
        foto_sekretariat: "foto_sekretariat",
        surat_pernyataan: "surat_pernyataan",
        lainnya: "rekomendasi",
      };

      const backendField = fieldMapping[fileCategory] || "rekomendasi";
      formData.append(backendField, selectedFile);

      const response = await axios.post(
        `${API_MAI_FALI}dokumen-ormas`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted);
          },
        }
      );

      if (response.data.success) {
        setSuccess(true);
        setSelectedFile(null);
        setFileDescription("");
        setFileCategory("");
        setSelectedOrmas("");
        setUploadProgress(0);
        fetchUploadedFiles();
      }
    } catch (error) {
      console.error("Upload error:", error);
      setError(
        error.response?.data?.message || "Terjadi kesalahan saat upload file"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteFile = async (fileId) => {
    if (window.confirm("Apakah Anda yakin ingin menghapus file ini?")) {
      try {
        const response = await axios.delete(
          `${API_MAI_FALI}dokumen-ormas/${fileId}`
        );
        if (response.data.success) {
          fetchUploadedFiles();
        }
      } catch (error) {
        console.error("Error deleting file:", error);
      }
    }
  };

  const handlePreviewFile = (file) => {
    setPreviewFile(file);
    setPreviewModal(true);
  };

  const getFileIcon = (fileType) => {
    if (fileType.includes("pdf")) return "tim-icons icon-single-copy-04";
    if (fileType.includes("image")) return "tim-icons icon-image-02";
    if (fileType.includes("word")) return "tim-icons icon-single-copy-04";
    if (fileType.includes("excel")) return "tim-icons icon-chart-bar-32";
    return "tim-icons icon-single-copy-04";
  };

  const fileCategoryOptions = [
    { value: "akta_pendirian", label: "Akta Pendirian" },
    { value: "skt_ahu", label: "SKT/AHU" },
    { value: "surat_pengesahan", label: "Surat Pengesahan" },
    { value: "surat_domisili", label: "Surat Domisili" },
    { value: "program_kerja", label: "Program Kerja" },
    { value: "biodata_pengurus", label: "Biodata Pengurus" },
    { value: "ktp_pengurus", label: "KTP Pengurus" },
    { value: "npwp_ormas", label: "NPWP ORMAS" },
    { value: "foto_sekretariat", label: "Foto Sekretariat" },
    { value: "surat_pernyataan", label: "Surat Pernyataan" },
    { value: "lainnya", label: "Lainnya" },
  ];

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  <i className="tim-icons icon-cloud-upload-94 text-primary" />
                  Upload Dokumen ORMAS
                </CardTitle>
                <p className="text-muted">
                  Upload dokumen-dokumen yang diperlukan untuk melengkapi data
                  Organisasi Kemasyarakatan.
                </p>
              </CardHeader>
              <CardBody>
                {success && (
                  <Alert color="success">File berhasil diupload!</Alert>
                )}

                {error && <Alert color="danger">{error}</Alert>}

                <Form onSubmit={handleUpload}>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Pilih ORMAS *</Label>
                        <Input
                          type="select"
                          value={selectedOrmas}
                          onChange={(e) => setSelectedOrmas(e.target.value)}
                          required
                        >
                          <option value="">Pilih Organisasi</option>
                          {ormasList.map((ormas) => (
                            <option key={ormas.id} value={ormas.id}>
                              {ormas.nama}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Kategori Dokumen *</Label>
                        <Input
                          type="select"
                          value={fileCategory}
                          onChange={(e) => setFileCategory(e.target.value)}
                          required
                        >
                          <option value="">Pilih Kategori</option>
                          {fileCategoryOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Nama Dokumen *</Label>
                        <Input
                          type="text"
                          value={fileDescription}
                          onChange={(e) => setFileDescription(e.target.value)}
                          placeholder="Masukkan nama/deskripsi dokumen"
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Pilih File *</Label>
                        <Input
                          type="file"
                          onChange={handleFileSelect}
                          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                          required
                        />
                        <small className="text-muted">
                          Format yang didukung: PDF, DOC, DOCX, JPG, PNG
                        </small>
                      </FormGroup>
                    </Col>
                  </Row>

                  {uploadProgress > 0 && (
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label>Progress Upload</Label>
                          <Progress value={uploadProgress} />
                        </FormGroup>
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col md="12" className="text-right">
                      <Button type="submit" color="primary" disabled={loading}>
                        {loading ? "Uploading..." : "Upload Dokumen"}
                      </Button>
                    </Col>
                  </Row>
                </Form>

                <hr />

                <h5>Dokumen yang Telah Diupload</h5>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Nama Dokumen</th>
                      <th>ORMAS</th>
                      <th>Kategori</th>
                      <th>Ukuran</th>
                      <th>Tanggal Upload</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uploadedFiles.map((file, index) => {
                      // Get the file path and name from the dokumen_ormas fields
                      const fileFields = [
                        "akta_pendirian",
                        "skt_ahu",
                        "pengesahan_kemenkumham",
                        "surat_domisili",
                        "program_kerja_semester_1",
                        "program_kerja_semester_2",
                        "npwp",
                        "foto_sekretariat",
                        "surat_pernyataan",
                        "rekomendasi",
                      ];

                      const fileField = fileFields.find(
                        (fieldName) => file[fieldName]
                      );
                      const fileName = fileField
                        ? file[fileField].split("/").pop()
                        : "Unknown";
                      const fileType = fileName.split(".").pop() || "";

                      return (
                        <tr key={file.id}>
                          <td>{index + 1}</td>
                          <td>
                            <i className={getFileIcon(fileType)} />
                            {fileName}
                          </td>
                          <td>{file.nama_ormas || "-"}</td>
                          <td>
                            <Badge color="info">{fileField || "Dokumen"}</Badge>
                          </td>
                          <td>-</td>
                          <td>
                            {new Date(
                              file.created_at || Date.now()
                            ).toLocaleDateString("id-ID")}
                          </td>
                          <td>
                            <Button
                              color="info"
                              size="sm"
                              className="mr-1"
                              onClick={() => handlePreviewFile(file)}
                            >
                              <i className="tim-icons icon-zoom-split-in" />
                              Preview
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleDeleteFile(file.id)}
                            >
                              <i className="tim-icons icon-simple-remove" />
                              Hapus
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>

                {uploadedFiles.length === 0 && (
                  <Alert color="info">Belum ada dokumen yang diupload.</Alert>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal Preview File */}
        <Modal
          isOpen={previewModal}
          toggle={() => setPreviewModal(false)}
          size="lg"
        >
          <ModalHeader toggle={() => setPreviewModal(false)}>
            Preview Dokumen:{" "}
            {(() => {
              if (!previewFile) return "Unknown";
              const fileFields = [
                "akta_pendirian",
                "skt_ahu",
                "pengesahan_kemenkumham",
                "surat_domisili",
                "program_kerja_semester_1",
                "program_kerja_semester_2",
                "npwp",
                "foto_sekretariat",
                "surat_pernyataan",
                "rekomendasi",
              ];
              const fileField = fileFields.find(
                (fieldName) => previewFile[fieldName]
              );
              return fileField
                ? previewFile[fileField].split("/").pop()
                : "Unknown";
            })()}
          </ModalHeader>
          <ModalBody>
            {previewFile && (
              <div className="text-center">
                {(() => {
                  // Get the file path from the dokumen_ormas fields
                  const fileFields = [
                    "akta_pendirian",
                    "skt_ahu",
                    "pengesahan_kemenkumham",
                    "surat_domisili",
                    "program_kerja_semester_1",
                    "program_kerja_semester_2",
                    "npwp",
                    "foto_sekretariat",
                    "surat_pernyataan",
                    "rekomendasi",
                  ];

                  const fileField = fileFields.find(
                    (fieldName) => previewFile[fieldName]
                  );
                  const filePath = fileField ? previewFile[fileField] : null;
                  const fileName = filePath
                    ? filePath.split("/").pop()
                    : "Unknown";
                  const fileType = fileName.split(".").pop() || "";

                  if (!filePath) {
                    return <p>File tidak ditemukan</p>;
                  }

                  const fileUrl = `${API_MAI_FALI.replace(
                    "/api/",
                    "/uploads/"
                  )}${filePath}`;

                  return fileType.match(/^(jpg|jpeg|png|gif)$/i) ? (
                    <img
                      src={fileUrl}
                      alt={fileName}
                      style={{ maxWidth: "100%" }}
                    />
                  ) : (
                    <iframe
                      src={fileUrl}
                      width="100%"
                      height="500px"
                      title={fileName}
                    />
                  );
                })()}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setPreviewModal(false)}>
              Tutup
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default UploadDokumen;
